module.exports = __webpack_public_path__ + "media/images/icon/teacher-role-525e6565729f9c183cbf5583ac627459.svg";